import React, { useEffect } from 'react';
import { CloseSvg, StyledIconContainer, Image, Video } from './ModalComponent.styles';
import Modal from './Modal';

const MediaModal = ({ open, onClose, mediaUrl, type }) => {
  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <Modal isOpen={open} onClose={onClose} fade padding={0} height={'80%'} maxWidth={'60%'} width={'auto'}>
      <StyledIconContainer onClick={onClose}>
        <CloseSvg />
      </StyledIconContainer>
      {type === 'photo' && <Image src={mediaUrl} />}
      {type === 'video' && (
        <Video controls>
          <source src={mediaUrl} type="video/mp4" />
        </Video>
      )}
    </Modal>
  );
};

export default MediaModal;
